import { Drawer, Space } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { BiTrash } from "react-icons/bi";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { EDGE_KINDS } from "utils/constants";
import ConditionListEditor from "./ConditionListEditor";

const ConditionsPanel = ({
  edge,
  variables = [],
  sourceName,
  targetName,
  onChange,
  onMetaChange,
  onDelete,
  onClose,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const FORM = t("FORM", { returnObjects: true });
  const POSSIBLE_STATUSES = FORM.POSSIBLE_STATUSES;
  const CONDITIONS = POSSIBLE_STATUSES.CONDITIONS;
  const KIND_LABELS = POSSIBLE_STATUSES.KINDS || {};
  const conditions = get(edge, "data.conditions", []);
  const kind = get(edge, "data.kind") || EDGE_KINDS.CONDITION;
  const kindOptions = Object.values(EDGE_KINDS).map((value) => ({
    value,
    label: KIND_LABELS[value] || value,
  }));

  return (
    <Drawer
      open={edge !== null && edge !== undefined}
      onClose={onClose}
      width={440}
      title={`${sourceName || "—"} → ${targetName || "—"}`}
    >
      <Space
        direction="vertical"
        size={16}
        className="canvas-editor__full-width"
      >
        <Select
          showSearch
          label={POSSIBLE_STATUSES.EDGE_KIND || "Type de transition"}
          placeholder={POSSIBLE_STATUSES.EDGE_KIND || "Type de transition"}
          options={kindOptions}
          value={kind}
          onChange={(value) => onMetaChange("kind", value)}
        />
        {kind === EDGE_KINDS.EVENT ? (
          <Input
            label={POSSIBLE_STATUSES.EVENT || "Événement"}
            placeholder={POSSIBLE_STATUSES.EVENT || "Événement"}
            value={get(edge, "data.event", "") || ""}
            onChange={(e) => onMetaChange("event", e.target.value)}
          />
        ) : null}
        {kind === EDGE_KINDS.TIMER ? (
          <Input
            type="number"
            label={POSSIBLE_STATUSES.DELAY_SECONDS || "Délai (secondes)"}
            placeholder={POSSIBLE_STATUSES.DELAY_SECONDS || "Délai (secondes)"}
            value={get(edge, "data.delaySeconds") ?? ""}
            onChange={(e) =>
              onMetaChange(
                "delaySeconds",
                e.target.value === "" ? null : Number(e.target.value),
              )
            }
          />
        ) : null}
        {kind === EDGE_KINDS.CONDITION ? (
          <ConditionListEditor
            conditions={conditions}
            variables={variables}
            labels={CONDITIONS}
            onChange={onChange}
          />
        ) : null}
        <Button type="danger--outlined" onClick={onDelete}>
          <BiTrash size={18} /> {FORM.DELETE_TRANSITION}
        </Button>
      </Space>
    </Drawer>
  );
};

export default ConditionsPanel;
